export const AGENT_RECEIPT = 'AGENT_RECEIPT';
export const agentMoneyReceiptTags = [
  'Agent_Money_receipt',
  'Agent_Money_receipt',
];
